import PropTypes from "prop-types";
import React from "react";
import ProductRail from "web/react/components/product-rail/product-rail";
import { RelatedProductsSectionPropType } from "web/types/related-products";
import AjaxProductRail from "web/react/components/product-rail/ajax-product-rail";
import styles from "./related-products-rails.css";

function RelatedProductsRails({ sections, features }) {
    const RELATED_DESIGNER_ENDPOINT = "modules/product/related_products_more_from_designer";
    return sections.map((section) => {
        if (section.lazy_load == true) {
            // We can only currently load "more from designer" rails asynchronously
            if (section.component != "related-products-more-from-designer") {
                return null;
            }
            return (
                <AjaxProductRail
                    key={section.label}
                    endpoint={RELATED_DESIGNER_ENDPOINT}
                    hiddenProductsCount={section.hidden_products_count}
                    label={section.label}
                    productSlug={section.product_slug}
                    productUid={section.product_uid}
                    title={section.title}
                    className={styles.railWrapper}
                    railClassName={styles.rail}
                    features={features}
                />
            );
        }

        // If there are no products on the rail, hide it
        if (section.related_products.length == 0) {
            return null;
        }

        return (
            <ProductRail
                key={section.label}
                hiddenProductsCount={section.hidden_products_count}
                products={section.related_products}
                title={section.title}
                label={section.label}
                viewMoreUrl={section.view_more_url}
                className={styles.railWrapper}
                railClassName={styles.rail}
                features={features}
            />
        );
    });
}

RelatedProductsRails.propTypes = {
    sections: PropTypes.arrayOf(RelatedProductsSectionPropType).isRequired,
    features: PropTypes.objectOf(PropTypes.string),
};

export default RelatedProductsRails;
